import { Box, Button, Flex, Text, textEllipsis } from "@100mslive/react-ui";
import {
  UserPreferencesKeys,
  defaultPreviewPreference,
  useUserPreferences,
} from "./hooks/useUserPreferences";

import { ExitIcon } from "@100mslive/react-icons";
import { Header } from "./Header";
import React from "react";
import { ToastManager } from "./Toast/ToastManager";
import { getRoutePrefix } from "../common/utils";
import { useNavigation } from "./hooks/useNavigation";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const PostLeave = () => {
  const { t } = useTranslation();
  const navigate = useNavigation();
  const { roomId, role } = useParams();
  const [previewPreference] = useUserPreferences(
    UserPreferencesKeys.PREVIEW,
    defaultPreviewPreference
  );
  return (
    <Flex direction="column" css={{ size: "100%" }}>
      <Box css={{ h: "$18", "@md": { h: "$32" } }} data-testid="header">
        <Header isPreview />
      </Box>
      <Flex
        justify="center"
        direction="column"
        align="center"
        css={{ bg: "$mainBg", flex: "1 1 0", position: "relative" }}
      >
        <Text variant="h2" css={{ fontWeight: "$semiBold" }}>
          👋
        </Text>
        <Text
          variant="h4"
          css={{ color: "$textHighEmp", fontWeight: "$semiBold", mt: "$12" }}
        >
          {t("fm_you_out_room", {
            name: t(getRoutePrefix() ? "lbl_stream" : "lbl_room"),
          })}
          {/* Bạn đã rời khỏi {getRoutePrefix() ? "phát trực tiếp" : "phòng"} */}
        </Text>
        <Text
          variant="body1"
          css={{
            color: "$textMedEmp",
            mt: "$8",
            fontWeight: "$regular",
            textAlign: "center",
          }}
        >
          {t("lbl_have_a_nice_day")}
          {/* Chúc một ngày tốt lành */}
          {previewPreference.name && (
            <Box as="span" css={{ ...textEllipsis(100) }}>
              , {previewPreference.name}
            </Box>
          )}
          !
        </Text>
        <Flex css={{ mt: "$14", gap: "$10", alignItems: "center" }}>
          <Text
            variant="body1"
            css={{ color: "$textMedEmp", fontWeight: "$regular" }}
          >
            {t("lbl_join_again")}
          </Text>
          <Button
            onClick={() => {
              let previewUrl = "/preview/" + roomId;
              if (role) previewUrl += "/" + role;
              navigate(previewUrl);
              ToastManager.clearAllToast();
            }}
            data-testid="join_again_btn"
          >
            <ExitIcon />
            <Text css={{ ml: "$3", fontWeight: "$semiBold", color: "inherit" }}>
              {t("lbl_click_here")}
            </Text>
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default PostLeave;
